import { render, staticRenderFns } from "./DomInfo.vue?vue&type=template&id=1d3a98c4&scoped=true"
import script from "./DomInfo.vue?vue&type=script&lang=js"
export * from "./DomInfo.vue?vue&type=script&lang=js"
import style0 from "./DomInfo.vue?vue&type=style&index=0&id=1d3a98c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3a98c4",
  null
  
)

export default component.exports